import { IFieldDefinitionLogic } from '../../../interfaces/ifield-definition-logic.interface';
import { TextMetadataFieldDefLogic } from './text-metadata-field-def-logic';

export class FormInstanceNameFieldDefinitionLogic extends TextMetadataFieldDefLogic implements IFieldDefinitionLogic {
    // Constructor.
    public constructor() {
        super('name');
    }

    public get canParticipateInFlexFieldBehavior(): boolean {
        return true;
    }

    public get isNonFlexFieldButCanParticipateInFlexFieldBehavior(): boolean {
        return true;
    }
}
